import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const Container = styled.div`
  .modal {
    padding-top: 16px;

    border-radius: 4px;
    background-color: ${GrayColors["G-0"]};
  }
`;

export const Body = styled.div`
  padding: 25px 30px 30px 30px;
`;

export const Close = styled.div`
  position: absolute;
  top: -6px;
  right: 10px;

  color: ${GrayColors["G-4"]};

  cursor: pointer;

  &:hover {
    color: ${GrayColors["G-7"]};
  }
`;

export const Description = styled.div`
  margin-bottom: 20px;
  border-bottom: 1px solid ${GrayColors["G-1-5"]};
  padding-bottom: 20px;
`;

export const Label = styled.div`
  margin-bottom: 8px;
`;

export const DropdownOption = styled.div`
  .checkmark-option {
    height: 32px;
  }
`;

export const DropdownFooter = styled.div`
  border-top: 1px solid ${GrayColors["G-1-5"]};
  padding: 13px 14px;
`;
